import PropTypes from 'prop-types';
import React from 'react';

/**
 * Renders a heading based on either:
 * - Boolean props: isH3, isH4, isH5 (fallbacks to h2 if none are true)
 * - Or a numeric `customHeadingLevel` prop for more dynamic control (e.g. level={4})
 */
const SemanticHeader = ({
  isH3,
  isH4,
  isH5,
  customHeadingLevel,
  children,
  ...props
}) => {
  const headingLevel = customHeadingLevel ?? (isH3 ? 3 : isH4 ? 4 : isH5 ? 5 : 2);

  const Tag = `h${Math.min(6, Math.max(1, headingLevel))}`;
  return (
    <Tag {...props}>
      {children}
    </Tag>
  );
};

SemanticHeader.propTypes = {
  isH3: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  isH4: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  isH5: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  customHeadingLevel: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default SemanticHeader;
